export const RAID_STATUS = {
  REQUESTED: 'requested',
  INITIATED: 'initiated',
  ONGOING: 'ongoing',
  SHIELDS_VULNERABLE: 'shieldsVulnerable',
  ATTACKER_DEFEATED: 'attackerDefeated',
  ATTACKER_RETREATED: 'attackerRetreated',
  RAID_SUCCESSFUL: 'raidSuccessful',
  DEMILITARIZED: 'demilitarized',
};
